__turbopack_context__.v({
  "item": "index-module__6Yrp8a__item",
  "visible": "index-module__6Yrp8a__visible",
});
